Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.DateField = (function () {

    function DateField() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.setInputValue = function () {
            if (this.input && this.value) {
                this.input.value = Monet.Format.Date.formatToLocale(this.value);
            }
        };

        this.setValue = function (value) {
            this.value = value;
            this.setInputValue();
        };

        this.getValue = function () {
            let formattedDate = '';
            if (this.input){
                this.value = this.input.value;
            }

            if (this.value) {
              formattedDate = Monet.Format.Date.parseLocaleToISOString(this.value);
            }

            return formattedDate;
        };

        this.createElement = function () {

            this.input = this.input || document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'dateField';
            this.input.autocomplete = "off";

            if(this.maxSize){
                this.input.maxLength = this.maxSize;
            }

            this.setValue(this.value);

            this.rootEl.appendChild(this.input);

        };

        this.setOnSelectCallback = function (callback) {

            this.onSelectCallback = callback;

        };

        this.initializeSpecialBehavior = function () {

            const monetDateFormat = Monet.I18n.locale.dateFormat.toLowerCase();
            this.jdDateFormat = monetDateFormat.replace("yyyy", "yy");

            let interval;

            const options = {
                dateFormat: this.jdDateFormat,
                beforeShow: (_, dpInstance) => {
                  $('main').append($('#ui-datepicker-div'));

                  if (interval) clearInterval(interval);

                  interval = setInterval(() => {
                    const { top, height } = this.input.getBoundingClientRect();
                    const updatedTop = `${(top + height)}px`;

                    dpInstance.dpDiv.css({ top: updatedTop });
                  }, 10);
                },
                onClose: () => {
                  if (interval) clearInterval(interval);
                }
            };

            if (this.onSelectCallback) {
                options.onSelect = this.onSelectCallback;
            }

            this.setListenerFocusOnEntityField(this.input);

            $(this.input).datepicker(options);

        };

        this.setListenerFocusOnEntityField = (input) => {
            input.addEventListener("focus", (event) => {
              this.currentValue = event.target.value;
            });
        };

        this.onDatePickerClose = (field, changedValueTarget) => {
            try {
                const valueFormated = field.getValue();
                const valueToTest = this.getValueToTest(valueFormated, field, changedValueTarget);
                const valueIsValid = this.testIfIsADateOrInvalidDate(valueToTest, changedValueTarget);
                this.setValueToField(valueIsValid, valueFormated, field, changedValueTarget);
            } catch (error) {
                new Monet.Exception
                    .ReturnError(
                        this,
                        "Trying execute action on Blur event in a Date/DateTime Field"
                    )
                    .console();
            }
        };

        this.setValueToField = (valueIsValid, valueFormated, field, changedValueTarget) => {
            if (valueIsValid) {
                field.setValue(valueFormated);
            } else {
                changedValueTarget.value = field.currentValue;
            }
        };

        this.getValueToTest = (valueFormated, field, changedValueTarget) => {
            const isARangeField = checkIfIsRangeField(valueFormated);
            const getIniOrFinDate = () => {
                if(field.inputIni || field.inputFin) {
                    switch(changedValueTarget) {
                        case field.inputIni :
                            return "ini";
                        case field.inputFin :
                            return "fin";
                    }
                }
            };

            if(isARangeField) {
                const iniOrfinDate = getIniOrFinDate();
                return valueFormated[iniOrfinDate];
            } else {
                return valueFormated;
            }
        };

        const checkIfIsRangeField = (valueFormated) => {
            if(typeof valueFormated === 'object'
                && (valueFormated.hasOwnProperty('ini') && valueFormated.hasOwnProperty('fin')))
            {
                return true;
            } else {
                return false;
            }
        };

        this.testIfIsADateOrInvalidDate = function(valueFormated, changedValueTarget) {

            if (moment(valueFormated).isValid() || changedValueTarget.value == '') {
                return true;
            } else {
                return false;
            }
        };

        this.render = function () {

            this.createElement();
            this.initializeSpecialBehavior();
            return this.rootEl;

        };

    }

    return DateField;

}());
